import React from 'react'
import { Box, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'

import AddIcon from '@mui/icons-material/Add'
import { HeaderSearchButton, HeaderSearchTextField } from '~/src/components/molecules'

interface IHeaderOrderStatementOfAccountListProps {
  searchValue: string
  handleSearchValue: (event: React.ChangeEvent<HTMLInputElement>) => void
  onSearch?: () => void
  isLoading: boolean
}

export const HeaderStatementOfAccountList: React.FC<IHeaderOrderStatementOfAccountListProps> = ({
  searchValue,
  handleSearchValue,
  onSearch,
  isLoading,
}): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const handleNavigate = () => {
    navigate('/admin/order/statement-of-account/add', {
      state: {
        prevLocationState: { ...location }
      }
    })
  }

  return (
    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={'2px'}>
      <Box display={'flex'} alignItems={'center'}>
        <HeaderSearchTextField
          size={'small'}
          placeholder={t('statement_account_list.keyword')}
          value={searchValue}
          onChange={handleSearchValue}
        />
        <HeaderSearchButton
          buttonText={t('statement_of_account_list.search')}
          isLoading={isLoading}
          onClick={onSearch}
        />
      </Box>

      <Button
        type={'submit'}
        startIcon={<AddIcon />}
        variant="contained"
        sx={{
          fontFamily: 'Roboto',
          fontSize: 15,
          lineHeight: '26px',
          fontWeight: 500,
          fontStyle: 'normal',
          letterSpacing: 0.46,
        }}
        onClick={handleNavigate}
      >
        {t('statement_of_account_list.add_new')}
      </Button>
    </Box>
  )
}
